module.exports = __webpack_public_path__ + "img/pin(circle-x-large-004d40)-icon(awesome-car-medium)-@2x-2.7bbbed77.png";